import { useEffect, useMemo, useState } from "react";
import { api } from "../lib/api";
import VideoCard from "../components/VideoCard";
import SkeletonRow from "../components/SkeletonRow";

export default function ViralVideos() {
    const [videos, setVideos] = useState([]);
    const [active, setActive] = useState("All");
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get("/videos/viral").then((r) => { setVideos(r.data); setLoading(false); });
    }, []);

    const cats = useMemo(() => {
        const unique = new Set();
        videos.forEach((v) => {
            const c = (v.category || "").trim();
            if (c) unique.add(c);
        });
        return ["All", ...Array.from(unique).sort((a, b) => a.localeCompare(b))];
    }, [videos]);

    const filtered = active === "All" ? videos : videos.filter((v) => v.category === active);

    return (
        <div data-testid="viral-page" className="pt-28 pb-16 mx-auto max-w-[1600px] px-6 lg:px-10">
            <div className="mb-6">
                <h1 className="font-display text-5xl sm:text-6xl font-black tracking-tight">Viral Videos</h1>
            </div>

            {cats.length > 1 && (
                <div data-testid="viral-cat-tabs" className="flex gap-2 flex-wrap mb-10">
                    {cats.map((c) => (
                        <button
                            key={c}
                            data-testid={`viral-cat-${c.replace(/\s+/g, "-").toLowerCase()}`}
                            onClick={() => setActive(c)}
                            className={`text-xs font-semibold px-4 py-2 rounded-full transition-colors ${
                                active === c
                                    ? "bg-[#FFD400] text-black"
                                    : "bg-white/5 text-white/80 border border-white/10 hover:bg-white/10"
                            }`}
                        >
                            {c}
                        </button>
                    ))}
                </div>
            )}

            {loading ? (
                <SkeletonRow />
            ) : filtered.length === 0 ? (
                <p className="text-white/50 text-sm" data-testid="viral-empty">No videos in this category yet.</p>
            ) : (
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                    {filtered.map((v) => <VideoCard key={v.id} video={v} />)}
                </div>
            )}
        </div>
    );
}
